// Comes from here: https://github.com/jpalumickas/use-window-focus

import React from 'react'

const checkFocus = () => Boolean(document?.hasFocus())

const useWindowFocus = () => {
  const [focused, setFocused] = React.useState(checkFocus)

  React.useEffect(() => {
    setFocused(checkFocus())

    const onFocus = () => setFocused(true)
    const onBlur = () => setFocused(false)

    window.addEventListener('focus', onFocus)
    window.addEventListener('blur', onBlur)

    return () => {
      window.removeEventListener('focus', onFocus)
      window.removeEventListener('blur', onBlur)
    }
  }, [])

  return focused
}

export default useWindowFocus
